import { render, staticRenderFns } from "./CustomGrid.vue?vue&type=template&id=5db14f0b"
import script from "./CustomGrid.vue?vue&type=script&lang=js"
export * from "./CustomGrid.vue?vue&type=script&lang=js"
import style0 from "./CustomGrid.vue?vue&type=style&index=0&id=5db14f0b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports